import { Component, OnInit, Input, ViewChild, Inject, ComponentRef,} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

import { Type } from '@angular/core';

import { CreateDialog } from './createDialog.service';
import { InnerComponent } from './innerComponent';
import { DialogDirective } from '../../directives/dialog.directive';
import { TranslateService } from '@ngx-translate/core';



export interface DialogData {
  compo: Type<any>,
  dataToRenderedComponent: any,
  title: string,
  instance:CreateDialog,
  firstButtonName:string,
  secondButtonName:string,
  hasOkBtn:boolean,
  hasCancelBtn:boolean
}


@Component({
  selector: 'bi-dialog',
  templateUrl: './bi-dialog.component.html',
  styleUrls: ['./bi-dialog.component.scss'],
})
export class BiDialog implements OnInit {
  @ViewChild(DialogDirective, { static: true }) dialoghost!: DialogDirective;
  componentRef!:ComponentRef<any>;
  lang: string | null = null;
  constructor(
    public dialogRef: MatDialogRef<BiDialog>,
    @Inject(MAT_DIALOG_DATA) public RecivedData: DialogData,
    private translateService: TranslateService
  ) { 

  }
  ngOnInit() {
    this.loadComponent()
    this.lang= localStorage.getItem("lang")?localStorage.getItem("lang"):'en' ;
  }

  loadComponent() {
    const viewContainerRef = this.dialoghost?.viewContainerRef;
    viewContainerRef.clear();

    this.componentRef = viewContainerRef.createComponent<InnerComponent>(this.RecivedData?.compo);
    this.componentRef.instance.data /*property to receive data*/= this.RecivedData?.dataToRenderedComponent;

  }
  Canel(onclose = false): void {
    this.componentRef.instance.OnCancel(onclose);
    this.RecivedData?.instance.DialogReturnSubject.next(this.componentRef.instance.outputValue/*property to out*/);
    this.dialogRef.close();
    this.componentRef.destroy();
  }

 async Ok():Promise<void> {
  let returnValue = await this.componentRef.instance.OnOk();
  let closeDialog = returnValue !== undefined ? returnValue : true;
  if(closeDialog){
    this.RecivedData?.instance.DialogReturnSubject.next(this.componentRef.instance.outputValue/*property to out*/);
    this.dialogRef.close();
    setTimeout(()=>{
      this.componentRef.destroy();
    })
  }
  }
}


